import { ColorClasses } from '@/shared/types/stepper';
import { cn } from '@/shared/utils/cn';

interface StepConnectorProps {
  colorClasses: ColorClasses;
  vertical?: boolean;
}

/**
 * StepConnector - Línea conectora entre pasos
 * Color: según el color del stepper (colorClasses.line).
 * En horizontal, la línea usa porcentajes respecto al ancho de la celda del paso para alinearse al icono (38px) y alcanzar el siguiente.
 */
export const StepConnector = ({ colorClasses, vertical = false }: StepConnectorProps) => {
  if (!vertical) {
    return (
      <div
        className={cn(
          'ui-pointer-events-none ui-absolute ui-top-[19px] ui-h-0.5',
          'ui-left-[calc(50%+19px)] ui-w-[calc(100%-38px)]',
          colorClasses.line
        )}
      />
    );
  } else {
    return (
      <div
        className={`ui-absolute ui-left-[19px] ui-top-[49px] ui-h-[22px] ui-w-0.5 ${colorClasses.line}`}
      />
    );
  }
};
